/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component007.less';
interface IComponents007Props {
  text: string;
  img: string;
}

const Components007: React.FunctionComponent<IComponents007Props> = ({
  text,
  img,
}) => (
  <>
    <div className="component007">
      <div className="tip-text" dangerouslySetInnerHTML={{ __html: text }} />
      <img
        src={require(`../../../../../assets/${img}`).default}
        alt=""
        className="component007-person"
      />
    </div>
  </>
);

export default Components007;
